import React from "react";
import { Sparkles } from "lucide-react";
import { ThemeType } from "../../types";
import { getThemeColors } from "../../utils/theme";

interface MembershipStatsCardProps {
  points: string | number;
  rank: string | number;
  theme: ThemeType;
  dartsliveName?: string;
  eventGroupName?: string;
}

const MembershipStatsCard: React.FC<MembershipStatsCardProps> = ({
  points,
  rank,
  theme,
  dartsliveName,
  eventGroupName,
}) => {
  const colors = getThemeColors(theme);
  const dividerColorByTheme: Record<ThemeType, string> = {
    red: "rgba(251,113,133,0.6)",
    amber: "rgba(251,191,36,0.6)",
    blue: "rgba(96,165,250,0.6)",
    emerald: "rgba(52,211,153,0.6)",
    slate: "rgba(148,163,184,0.6)",
  };

  return (
    <div className="relative rounded-2xl bg-slate-900 p-5 shadow-[0_12px_40px_-12px_rgba(0,0,0,0.4)] mb-8 overflow-hidden group text-left">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-[0.03] rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
      <div
        className={`absolute bottom-0 left-0 w-40 h-40 ${colors.glow} opacity-20 blur-[50px] -translate-x-1/2 translate-y-1/2 transition-colors duration-500`}
      />
      <div className="relative z-10 flex justify-between items-end">
        <div>
          {(dartsliveName || eventGroupName) && (
            <div className="mb-1">
              {dartsliveName && (
                <p className="text-slate-400 text-xs">
                  <span className="text-slate-500 text-[10px] uppercase tracking-widest mr-1">
                    DARTSLIVEカード名
                  </span>
                  {dartsliveName}
                </p>
              )}
              {dartsliveName && eventGroupName && (
                <div
                  className="mt-2 mb-4 h-px -mx-1 w-[calc(100%+0.5rem)]"
                  style={{ backgroundColor: dividerColorByTheme[theme] }}
                />
              )}
              {eventGroupName && (
                <p
                  className={`${colors.text} text-sm font-bold tracking-wide`}
                  style={{ textShadow: "0 0 8px currentColor" }}
                >
                  {eventGroupName}
                </p>
              )}
            </div>
          )}
          <div className="flex items-center gap-2 mb-2">
            <Sparkles className={`w-4 h-4 ${colors.text}`} />
            <p className="text-slate-400 text-[10px] font-bold tracking-[0.2em] uppercase">
              年間ポイント
            </p>
          </div>
          <div className="flex items-baseline gap-1">
            <span className="text-4xl font-black text-white tracking-tighter">
              {points}
            </span>
            <span className="text-slate-500 font-bold text-sm uppercase">
              pt
            </span>
          </div>
        </div>
        <div className="text-right">
          <p className="text-slate-400 text-[10px] font-bold tracking-[0.2em] uppercase mb-2">
            順位
          </p>
          <div className="flex items-baseline justify-end gap-1">
            <span
              className={`text-3xl font-black ${colors.text} tracking-tighter`}
            >
              {rank}
            </span>
            <span className="text-slate-500 font-bold text-sm uppercase">
              位
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipStatsCard;
